import React, {useContext} from 'react';

import {OrderContext} from 'views/order/OrderForm';
import {Input} from 'views/FormElements';

const QuantityInput = () => {
    const {values} = useContext(OrderContext);
    const isBulkOrderForm = values.isBulkOrderForm;

    if(isBulkOrderForm)
        return null;

    return <React.Fragment>
            <Input label="Quantity: " name="quantity" type="number" />
    </React.Fragment>
}


export default QuantityInput;


// WEBPACK FOOTER //
// ./src/views/order/input/QuantityInput.js